import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/face-reshaping"
    path="business/products/face-reshaping"
    element={<AsyncPage />}
  />,
];
